import React, { useEffect, useState } from "react";
import ChatHeader from "./Components/ChatHeader";
import { chatData } from "./helper";
import "./style.scss";
import ProfilePreview from "./Components/ProfilePreview";
import ChatMessages from "./Components/ChatMessages";
import MessageInput from "./Components/MessageInput";
import { useChatDetail } from "hooks/api/useChatDetail";
import MessageRequest from "./Components/ChatRequest";
import { useQueryClient } from "@tanstack/react-query";

const ChatConsole = ({
  messages,
  selectedChatId,
  onMessageSent,
  userChats,
  currentUserId,
  selectedThread,
  onBack,
  setSelectedThread,
}) => {
  const id = selectedThread?.aec_id;
  const queryClient = useQueryClient();

  const {
    data: chatDetail,
    isLoading,
    refetch,
  } = useChatDetail({
    id,

    onError: () => {
      setSelectedThread(null);
    },
  });

  useEffect(() => {
    refetch();

    if (chatDetail?.chat === undefined && !isLoading) {
      setSelectedThread(null);
      queryClient.invalidateQueries(["chat-threads"]);
    }
  }, [chatDetail]);

  return (
    <div
      className={`chat-console ${chatDetail?.request_exist ? "request-exist" : ""}`}
    >
      <ChatHeader
        selectedThread={selectedThread}
        reqAccepted={chatDetail?.chat?.request_exist}
        data={chatData}
        chatDetail={chatDetail?.chat}
        userChats={userChats}
        selectedChatId={selectedChatId}
        onBack={onBack}
      />
      {/* <ProfilePreview
        participants={chatData.participants}
        data={chatData}
        userChats={userChats}
        selectedChatId={selectedChatId}
      /> */}
      <ChatMessages
        chatData={chatData}
        userChats={userChats}
        selectedChatId={selectedChatId}
        messages={messages}
        currentUserId={currentUserId}
        participants={chatData.participants}
        selectedThread={selectedThread}
      />
      {chatDetail?.chat?.request_exist && selectedThread && selectedChatId ?(
        <MessageRequest selectedThread={chatDetail?.chat} refetch={refetch} />
      ) : (
        <MessageInput
          reqAccepted={chatDetail?.chat?.request_exist}
          selectedThread={selectedThread}
          userChats={userChats}
          messages={messages}
          chatDetail={chatDetail?.chat}
          can_send_message={chatDetail?.chat?.can_send_message}
          selectedChatId={selectedChatId}
          currentUserId={currentUserId}
          onMessageSent={onMessageSent}
        />
      )}
    </div>
  );
};

export default ChatConsole;
